/* eslint-disable no-console */
import ClickOutside from "vue-click-outside";
import axios from "axios";
const CancelToken = axios.CancelToken;
import SearchFilter from "@/components/Search/SearchFilter/SearchFilter.vue";
import filters from "@/components/Search/filters";
import { subdomains } from "@/common/consts";
import {
    getCurrentSubdomain,
    legacyPostSearch,
    navigateTo,
    sameSubdomain,
    isSmallDevice
} from "@/common/functions";
import { mapGetters } from "vuex";

const RECENT_SEARCHES_QUEUE_SIZE = 5;

export default {
    data() {
        return {
            requestCancelToken: null,
            searchTerm: "",
            preKeyboardSearchTerm: "",
            currentFilter: filters[0],
            filterIsOpen: false,
            searchInputFocus: false,
            searchInputAutoFocus: true,
            isKeyboardNavigating: false,
            keyboardSelectionIndex: null,
            suggestions: [],
            recentSearches: [],
            subdomain: getCurrentSubdomain(),
            isFocused: false
        };
    },
    methods: {
        isSmallDevice,
        getCurrentFilter() {
            const subdomain = getCurrentSubdomain();
            return filters.find(filter => filter.value === subdomain) || filters[0];
        },
        selectionIndexChange(i) {
            this.keyboardSelectionIndex = i >= 0 ? i : null;
        },
        getRecentSearches() {
            try {
                let recent = localStorage.getItem("recent-searches");
                recent = JSON.parse(recent);
                if (Array.isArray(recent)) {
                    return recent;
                }
                return [];
            } catch (e) {
                console.log("LocalStorage is not available.");
            }
        },
        onSearchInputFocus() {
            this.isFocused = true;
            if (this.searchInputAutoFocus) {
                this.searchInputAutoFocus = false;
            } else {
                this.searchInputFocus = true;
            }

            this.$store.commit("Screen/toggleSearchBoxFocus", this.isFocused);
        },
        onSearchInputBlur() {
            this.isFocused = false;
            // This timeout alows performing a search if focus is lost because
            // the user clicked in an autocomplete or recent search option.
            setTimeout(() => {
                this.searchInputAutoFocus = false;
                this.searchInputFocus = false;
            }, 500);

            this.$store.commit("Screen/toggleSearchBoxFocus", this.isFocused);
        },
        onSearchInputChange() {
            // Do not ping the suggestions API if the selected option is
            // WordFinder
            if (this.currentFilter.value === "wordfinder") {
                return true;
            }

            // If this is still part of the initial autofocus action, switch to
            // manual focus to enable the dropdowns.
            if (!this.searchInputFocus) {
                this.searchInputAutoFocus = false;
                this.searchInputFocus = true;
            }

            if (this.keyboardSelectionIndex !== null || this.isKeyboardNavigating) {
                // This means that the user is navigating through the elements
                // via keyboard. The search input text will change during this
                // time but a search should not be initiated.
                return true;
            }

            // Update the pre-keyboard term, so that we can refer to it during
            // keyboard navigation.
            this.preKeyboardSearchTerm = this.searchTerm;

            var vm = this;

            if (typeof this.requestCancelToken === "function") {
                this.requestCancelToken();
            }

            const getCurrentFilter = this.currentFilter.value;
            const locale = this.currentLanguage;
            const types = {
                www: "definition",
                examples: "example",
                quotes: "quote",
                reference: "reference",
                sentence: "sentence",
                spanish: "spanish",
                thesaurus: "thesaurus"
            };
            const type = types[getCurrentFilter];

            if (this.searchTerm !== "") {
                axios
                    .get(`${process.env.AUTOCOMPLETE_API}/words/autocomplete?type=${type}`, {
                        params: {
                            keywords: this.searchTerm,
                            type: (getCurrentFilter => {
                                switch (getCurrentFilter) {
                                    case subdomains.DEFINITION:
                                        "definition";
                                        break;
                                    case subdomains.ES:
                                        "sentence";
                                        break;
                                    case subdomains.ABBREVIATIONS:
                                        "reference";
                                        break;
                                    default:
                                        this.currentFilter.value;
                                }
                            })(getCurrentFilter),
                            lang: locale
                        },
                        cancelToken: new CancelToken(c => {
                            vm.requestCancelToken = c;
                        })
                    })
                    .then(
                        response => {
                            response = response.data;

                            if (response.status == 200) {
                                if (response.data && Array.isArray(response.data.results)) {
                                    let results = response.data.results;
                                    results = results.map(item => {
                                        var entry = {
                                            term: item.text, // we've left this to not broke anything that is using "term" property
                                            category: getCurrentFilter,
                                            ...item
                                        };

                                        if (item.url) {
                                            entry.url = item.url;
                                        }

                                        return entry;
                                    });
                                    vm.suggestions = results;
                                }
                            }
                        },
                        () => {}
                    );
            }
        },
        onSearchInputClickOutside() {
            this.searchInputFocus = false;
            this.searchInputAutoFocus = false;
        },
        onSearchInputEnter() {
            if (this.keyboardSelectionIndex === null) {
                this.onSearch();
            } else {
                if (this.showRecent) {
                    if (this.keyboardSelectionIndex === 0) {
                        this.recentSearchesClear();
                    } else {
                        const s = this.recentSearches[this.keyboardSelectionIndex - 1];
                        this.recentSearchSelect(s);
                    }
                } else if (this.showSuggestions) {
                    const suggestion = this.suggestions[this.keyboardSelectionIndex];
                    this.suggestionSelect(suggestion);
                }
                this.keyboardSelectionIndex = null;
            }
            this.preKeyboardSearchTerm = this.searchTerm;
            this.isKeyboardNavigating = false;
        },
        onSearchInputClick() {
            this.isKeyboardNavigating = false;
            this.searchInputFocus = true;
            if (isSmallDevice()) {
                const options = {
                    easing: "ease-in",
                    offset: -15,
                    force: true,
                    cancelable: true,
                    x: false,
                    y: true
                };
                const element = document.querySelector(".search-box-container");
                this.$scrollTo(element, 300, options);
            }
        },
        onClearButtonClick() {
            this.searchTerm = "";
            var vm = this;
            setTimeout(() => {
                vm.$refs.searchInputField.focus();
            }, 100);
        },
        onSearchButtonClick() {
            this.onSearch();
        },
        onUpKeyUp() {
            if (this.showRecent || this.showSuggestions) {
                this.isKeyboardNavigating = true;
                if (this.keyboardSelectionIndex === null) {
                    // It's not selecting anything at the moment, so set the
                    // index to the highest possible value.
                    this.keyboardSelectionIndex = this.maxKeyboardSelectionIndex;
                } else {
                    if (this.keyboardSelectionIndex === 0) {
                        this.keyboardSelectionIndex = null;
                    } else {
                        this.keyboardSelectionIndex--;
                    }
                }
            }
        },
        onDownKeyUp() {
            if (this.showRecent || this.showSuggestions) {
                this.isKeyboardNavigating = true;
                if (this.keyboardSelectionIndex === null) {
                    this.keyboardSelectionIndex = 0;
                } else {
                    // Determine the highest value that keyboardSelectionIndex
                    // can go.
                    let max = this.maxKeyboardSelectionIndex;

                    if (this.keyboardSelectionIndex >= max) {
                        // It's hit the highest possible value, loop it back to
                        // null to bring it to the search box.
                        this.keyboardSelectionIndex = null;
                    } else {
                        // It can go further.
                        this.keyboardSelectionIndex++;
                    }
                }
            }
        },
        onKeyUp(e) {
            const nullKeys = [
                "ArrowDown",
                "ArrowUp",
                "ArrowLeft",
                "ArrowRight",
                "Control",
                "Meta",
                "Shift"
            ];
            if (nullKeys.indexOf(e.key) < 0) {
                this.isKeyboardNavigating = false;
                this.keyboardSelectionIndex = null;
            }
        },
        filterToggle(isOpen) {
            this.filterIsOpen = isOpen;
        },
        filterSelect(f) {
            this.currentFilter = Object.assign({}, f);
        },
        recentSearchesClear() {
            try {
                localStorage.setItem("recent-searches", "[]");
                this.recentSearches = [];
            } catch (e) {
                console.log("LocalStorage is not available.");
            }
        },
        recentSearchSelect(s) {
            this.searchTerm = s.term;
            this.performSearch({
                ...s,
                searchType: "recent"
            });
        },
        recordRecentSearch(s) {
            // Do not record the search if it's a WF search.
            if (s.category === "wordfinder") return true;

            // Check if the search is part of the recent searches, and bring it
            // up to the top if yes.
            let index = this.recentSearches.findIndex(rs => {
                if (rs.term !== s.term) return false;
                if (rs.category !== s.category) return false;
                return true;
            });

            if (index > -1) {
                this.recentSearches.splice(index, 1);
            }

            this.recentSearches.unshift(s);

            // Trim off any searches until it's within the allowed max count.
            while (this.recentSearches.length > RECENT_SEARCHES_QUEUE_SIZE) {
                this.recentSearches.pop();
            }

            try {
                localStorage.setItem("recent-searches", JSON.stringify(this.recentSearches));
            } catch (e) {
                console.log("LocalStorage is not available.");
            }
        },
        suggestionSelect(suggestion) {
            this.searchTerm = suggestion.term;
            const searchObject = {
                term: suggestion.term,
                slug: suggestion.slug,
                category: this.currentFilter.value,
                searchType: "suggestion"
            };

            if (suggestion.url) {
                searchObject.url = suggestion.url;
            }

            this.performSearch(searchObject);
        },
        onSearch() {
            if (!this.searchTerm.length) return false;

            this.searchInputFocus = false;
            this.searchInputAutoFocus = false;

            this.performSearch({
                term: this.searchTerm,
                slug: this.searchTerm,
                category: this.currentFilter.value,
                searchType: "search"
            });
        },
        performSearch(s) {
            this.recordRecentSearch(s);

            // Probably not needed, but make sure this is a valid string just
            // in case.
            if (typeof s.term !== "string" || !s.term.length) {
                return false;
            }

            // If the suggestion (or recent search) entry contains a URL, just
            // go straight to that URL.
            if (s.url) {
                window.location.assign(s.url);
                return false;
            }

            const filter = this.currentFilter;
            const subdomain = s.searchType === "recent" ? s.category : filter.value;
            switch (subdomain) {
                case subdomains.WORDFINDER:
                    navigateTo(subdomains.WORDFINDER, `/unscramble/${s.term.replace(/\?/g, "_")}`);
                    return false;
                case subdomains.ES:
                    if (subdomain === "es") {
                        this.$router.push(`/frases/${s.term}`);
                    } else {
                        navigateTo(subdomain, `${s.term}`);
                    }
                    return false;
                case subdomains.SENTENCES:
                case subdomains.THESAURUS:
                    if (subdomain === subdomains.THESAURUS) {
                        this.$ga.event({
                            eventCategory: "Search",
                            eventAction: s.searchType,
                            eventLabel: s.term
                        });
                    }
                    if (sameSubdomain(this.$route.name, subdomain)) {
                        this.$router.push(`/${s.slug}`);
                    } else {
                        navigateTo(subdomain, `/${s.slug}`);
                    }
                    return false;
                case subdomains.DEFINITIONS:
                case subdomains.QUOTES:
                case subdomains.EXAMPLES:
                case subdomains.SPANISH:
                case subdomains.REFERENCE:
                default:
                    legacyPostSearch(subdomain, s.term);
            }
        }
    },
    mounted() {
        this.$refs.searchInputField.focus();
    },
    created() {
        this.recentSearches = this.getRecentSearches();
        this.currentFilter = this.getCurrentFilter();
    },
    computed: {
        placeholder() {
            if (this.getThesaurusHeadword) {
                return this.getThesaurusHeadword;
            } else {
                return this.$t("typeToSearch");
            }
        },
        showRecent() {
            return (
                this.recentSearches.length &&
                (this.searchTerm.length === 0 ||
                    (this.preKeyboardSearchTerm.length === 0 && this.isKeyboardNavigating)) &&
                this.searchInputFocus &&
                !this.searchInputAutoFocus &&
                this.currentFilter.value != "wordfinder"
            );
        },
        showSuggestions() {
            return (
                this.searchTerm.length > 0 &&
                this.searchInputFocus &&
                this.hasSuggestions &&
                this.currentFilter.value != "wordfinder"
            );
        },
        filteredSuggestions() {
            var s = this.suggestions;
            if (!Array.isArray(s)) {
                s = [];
            }

            // The user is navigating, so the term in the search field may not
            // filter properly.
            if (this.keyboardSelectionIndex !== null || this.isKeyboardNavigating) return s;

            return s.filter(
                s =>
                    s.term.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1 &&
                    this.searchTerm.length
            );
        },
        hasSuggestions() {
            let fs = this.filteredSuggestions;
            return (
                fs.length > 1 ||
                (fs.length === 1 && this.searchTerm.toLowerCase() !== fs[0].term.toLowerCase())
            );
        },
        maxKeyboardSelectionIndex() {
            // If neither right-side dropdown is open, the value isn't
            // applicable.
            if (!this.showRecent && !this.showSuggestions) {
                return null;
            }

            if (this.showRecent) {
                return this.recentSearches.length;
            }

            if (this.showSuggestions) {
                return this.suggestions.length - 1;
            }

            return null;
        },
        ...mapGetters(["currentLanguage"]),
        ...mapGetters("Login", ["user"]),
        ...mapGetters("ThesaurusFilter", ["getThesaurusHeadword"])
    },
    watch: {
        keyboardSelectionIndex(i) {
            // If the new selection index landed on an entry, populate the
            // search box with the value from that entry.
            if (i !== null) {
                if ((this.showRecent && i >= 1) || (this.showSuggestions && i >= 0)) {
                    let newTerm;
                    if (this.showRecent) {
                        newTerm = this.recentSearches[i - 1].term;
                    } else {
                        newTerm = this.suggestions[i].term;
                    }

                    this.searchTerm = newTerm;
                }
            } else if (this.isKeyboardNavigating) {
                this.searchTerm = this.preKeyboardSearchTerm;
            }
        }
    },
    components: {
        SearchFilter,
        SearchRecent: () =>
            import(
                /* webpackChunkName: "searchRecent" */ "@/components/Search/SearchRecent/SearchRecent.vue"
            ),
        SearchSuggestions: () =>
            import(
                /* webpackChunkName: "searchSuggestions" */ "@/components/Search/SearchSuggestions/SearchSuggestions.vue"
            )
    },
    directives: {
        ClickOutside
    }
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchBox/SearchBox.js